import axios from 'axios';
import type { InternalAxiosRequestConfig } from 'axios';
import { API_CONFIG, getApiUrl } from '../config/apiConfig';

const API_BASE_URL = API_CONFIG.BASE_URL; 

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor for authentication
api.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const token = localStorage.getItem('token');
  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth APIs
export const authAPI = {
  login: async (credentials: { email: string; password: string }) => {
    const response = await api.post('/auth/login', credentials);
    return response.data;
  },
  register: async (userData: { email: string; password: string; name: string }) => {
    const response = await api.post('/auth/register', userData);
    return response.data;
  },
};

// Module APIs
export const moduleAPI = {
  getAllModules: async () => {
    const response = await api.get('/modules');
    return response.data;
  },
  getModuleById: async (id: string) => {
    const response = await api.get(`/modules/${id}`);
    return response.data;
  },
  createModule: async (moduleData: any) => {
    const response = await api.post('/modules', moduleData);
    return response.data;
  },
  updateModule: async (id: string, moduleData: any) => {
    const response = await api.put(`/modules/${id}`, moduleData);
    return response.data;
  },
  deleteModule: async (id: string) => {
    const response = await api.delete(`/modules/${id}`);
    return response.data;
  },
};

// User APIs
export const userAPI = {
  getCurrentUser: async () => {
    const response = await api.get('/users/me');
    return response.data;
  },
  updateUser: async (userData: any) => {
    const response = await api.put('/users/me', userData);
    return response.data;
  },
};

export const uploadFile = async (file: File): Promise<{ url: string }> => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await fetch('/api/FileUpload/Upload', {
    method: 'POST',
    body: formData,
  });
  if (!response.ok) {
    throw new Error('Failed to upload file');
  }
  return response.json();
};

export default api; 